// import React, { useState } from "react";
// import Slider from "react-slick";
// import "../TestimonialSection/card.scss";
// import testimonialData from "./Teastimonial";

// const CardSlider = () => {
//   const [currentSlide, setCurrentSlide] = useState(0);

//   const settings = {
//     vertical: true,
//     infinite: true,
//     arrows: false,
//     dots: false,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 2000,
//     speed: 800,
//     pauseOnHover: false,
//     beforeChange: (oldIndex, newIndex) => {
//       setCurrentSlide(newIndex);
//     },
//   };

//   const getMiddleIndex = () => {
//     const middleOffset = Math.floor(settings.slidesToShow / 2);
//     return (currentSlide + middleOffset) % testimonialData.length;
//   };

//   const middleIndex = getMiddleIndex();

//   return (
//     <div className="testimonial-wrap">
//       <div className="container">
//         <div className="row align-items-center">
//           {/* align-items-center */}
//           <div className="col-md-12 col-lg-6 col-12">
//             <div className="left-column">
//               <p>Testimonial</p>
//               <p>Transformative Client <br/> Experience</p>
//               {/* <p>
//                 At Brand Craft, strategic thinking meets creative excellence
//                 delivering results that don’t just look good, but create lasting
//                 impact in the ever-evolving digital space.
//               </p> */}
//             </div>
//           </div>
//           <div className="col-md-9 col-lg-6 col-12">
//             <div className="hero__title" id="animatedHeading">
//               <Slider {...settings}>
//                 {testimonialData.map((item, index) => (
//                   <div key={index} className="slick-dupe">
//                     <div
//                       className={`custom-card animate ${
//                         index === middleIndex
//                           ? "animate--grow"
//                           : "animate--shrink"
//                       }`}
//                     >
//                       <div className="first-line">
//                         <div className="card-left">
//                           <img
//                             src={item.clientLogo}
//                             alt={item.name}
//                             className="logo-circle"
//                           />
//                           <span className="card-name">{item.name}</span>
//                         </div>
//                         <div className="card-right">
//                           <p className="card-title">{item.project}</p>
//                         </div>
//                       </div>
//                       <div className="description">
//                         <p>{item.description}</p>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </Slider>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CardSlider;

// File: components/TestimonialSlider/TestimonialSlider.jsx
import React, { useEffect, useRef, useState } from "react";
import "../TestimonialSection/card.scss";
// import "../TestimonialSection/carouselComponent.scss";
import {
  AnusayaFresh,
  Background,
  Heritage,
  IndiaCup,
  TennisCricket,
  WNF,
} from "..";
import testimonialData from "./Teastimonial";
import Aos from "aos";

const CardSlider = () => {
  const [selectedLogo, setSelectedLogo] = useState(testimonialData[0]);
  const [animating, setAnimating] = useState(false);
  const [curtainOpen, setCurtainOpen] = useState(true);
  const cardRef = useRef(null);
  const [logoPositions, setLogoPositions] = useState([]);

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  useEffect(() => {
    const zones = [
      { top: "80%", left: "48%" },
      { top: "42%", left: "84%" },
      { top: "72%", left: "14%" },
      { top: "80%", left: "80%" },
      { top: "20%", left: "5%" },
      { top: "5%", left: "50%" },
      { top: "50%", left: "5%" },
      { top: "90%", left: "60%" },
    ];

    const positions = testimonialData.map((_, i) => {
      const z = zones[i % zones.length];
      return {
        ...z,
        duration: 8 + Math.random() * 6,
        delay: Math.random() * 5,
      };
    });
    setLogoPositions(positions);
  }, []);

  const handleLogoClick = (item, event) => {
    if (animating || item === selectedLogo) return;

    // const logoRect = event.target.getBoundingClientRect();
    // const cardRect = cardRef.current.getBoundingClientRect();

    // const centerX = cardRect.left + cardRect.width / 2;
    // const centerY = cardRect.top + cardRect.height / 2;
    // const offsetX = logoRect.left + logoRect.width / 2 - centerX;
    // const offsetY = logoRect.top + logoRect.height / 2 - centerY;

    // setAnimating(true);
    // setCurtainOpen(false); // 1. Close curtain

    // setTimeout(() => {
    //   const card = cardRef.current;
    //   card.style.transition = "transform 0.6s ease, opacity 0.6s ease";
    //   card.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(0.8)`;
    //   card.style.opacity = "0";

    //   setTimeout(() => {
    //     card.style.transition = "none";
    //     card.style.transform = `translate(${-offsetX}px, ${-offsetY}px) scale(0.8)`;
    //     setSelectedLogo(item);

    //     requestAnimationFrame(() => {
    //       card.style.transition = "transform 0.6s ease, opacity 0.6s ease";
    //       card.style.transform = `translate(0, 0) scale(1)`;
    //       card.style.opacity = "1";
    //     });

    //     setTimeout(() => {
    //       setCurtainOpen(true); // 4. Open curtain
    //       setAnimating(false);
    //     }, 600);
    //   }, 600);
    // }, 400); // Wait for curtain close

    setAnimating(true);
    setCurtainOpen(false); // Close curtain instantly

    setTimeout(() => {
      // Directly set the new logo without animation
      setSelectedLogo(item);

      // Open curtain again
      setCurtainOpen(true);
      setAnimating(false);
    }, 200); // Keep curtain timing if you still want that effect
  };

  return (
    <div className="floating-bg">
      {testimonialData.map((item, index) => {
        const pos = logoPositions[index];

        return (
          <img
            key={index}
            src={item.clientLogo}
            alt={item.name}
            className={`floating-logo ${selectedLogo === item ? "active" : ""}`}
            style={{
              animationDuration: `${pos?.duration || 10}s`,
              animationDelay: `${pos?.delay || 0}s`,
              top: pos?.top || "50%",
              left: pos?.left || "50%",
            }}
            onMouseEnter={(e) => handleLogoClick(item, e)}
          />
        );
      })}
      <div className="heading-content">
        <p>Transformative Client Experience</p>
      </div>
      <div
        className="profile-card"
        ref={cardRef}
        data-aos="zoom-in"
        key={selectedLogo.name}
      >
        <div className="overlay"></div>
        <div className="profile-header">
          <img
            src={selectedLogo.clientLogo}
            alt="selected-logo"
            className="profile-pic"
          />
          <div className="profile-info">
            <h2>{selectedLogo.project}</h2>
            <p>{selectedLogo.name}</p>
          </div>
        </div>
        <hr className="divider" />
        <div className="profile-desc-wrapper">
         
          <div className="profile-desc">
            <p>{selectedLogo.description}</p>
          </div>
        </div>
      </div>
      {/* <div
        className="profile-card"
        ref={cardRef}
        data-aos="zoom-in"
        key={selectedLogo.name}
      >
        <img src={Background} alt="background" className="bg-image" />
         <div className="profile-content">
        <div className="profile-header">x
          <img
            src={selectedLogo.clientLogo}
            alt="selected-logo"
            className="profile-pic"
          />
          <div className="profile-info">
            <h2>{selectedLogo.project}</h2>
            <p>{selectedLogo.name}</p>
          </div>
        </div>
        <hr className="divider" />
        <div className="profile-desc-wrapper">
         
          <div className="profile-desc">
            <p>{selectedLogo.description}</p>
          </div>
        </div>
      </div>
      </div> */}
    </div>
  );
};

export default CardSlider;




 {/* <div
            className={`curtain-panel left-panel ${
              curtainOpen ? "open" : "close"
            }`}
          >
            <span className="quote-mark left-quote">“</span>
          </div>
          <div
            className={`curtain-panel right-panel ${
              curtainOpen ? "open" : "close"
            }`}
          >
            <span className="quote-mark right-quote">”</span>
          </div> */}